import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ASSET_VIEWS_CLASS_NAME = 'AssetViews';
export const ASSET_VIEWS_CLASS_SLOTS = ['root'] as const;

export type AssetViewsClassSlot = (typeof ASSET_VIEWS_CLASS_SLOTS)[number];

export interface AssetViewsClasses {
	root: string;
}

export type AssetViewsClassKey = keyof AssetViewsClasses;

export const getAssetViewsUtilityClass = (slot: string) =>
	generateUtilityClass(ASSET_VIEWS_CLASS_NAME, slot);

export const assetViewsClasses: AssetViewsClasses = generateUtilityClasses(
	ASSET_VIEWS_CLASS_NAME,
	['root'],
);

export default AssetViewsClasses;
